import React from 'react';
import './home.css'
import './adaptivity.css'
const Adaptive = () => {
    return ( <>
    <div className="adaptivelayout">
        <h6>
            افتح الموقع على الحاسوب لأفضل تجربة
        </h6>
    </div>
    </> );
}

export default Adaptive;